export default "__VITE_ASSET__3a78205e__$_?nuxt_component=async__"